// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("rescript/lib/js/belt_List.js");
var ImportEnrichmentFieldOptions$ReactHooksTemplate = require("./ImportEnrichmentFieldOptions.res.js");

var numericOperators = {
  hd: "eq",
  tl: {
    hd: "neq",
    tl: {
      hd: "gt",
      tl: {
        hd: "gte",
        tl: {
          hd: "lt",
          tl: {
            hd: "lte",
            tl: {
              hd: "blank",
              tl: {
                hd: "present",
                tl: /* [] */0
              }
            }
          }
        }
      }
    }
  }
};

var contextSelectOperators = {
  hd: "eq",
  tl: {
    hd: "neq",
    tl: {
      hd: "in_list",
      tl: {
        hd: "blank",
        tl: {
          hd: "present",
          tl: /* [] */0
        }
      }
    }
  }
};

function fieldKindForPath(path, fieldOptions) {
  switch (path) {
    case "context.campaign_uid" :
        return "ContextCampaignUid";
    case "context.feed_file.name" :
        return "ContextFreeText";
    case "context.pipeline" :
        return "ContextPipeline";
    case "context.source_type" :
        return "ContextSourceType";
    default:
      var field = ImportEnrichmentFieldOptions$ReactHooksTemplate.findByPath(fieldOptions, path);
      if (field !== undefined) {
        var dataType = field.dataType;
        var listOptions = field.listOptions;
        switch (dataType) {
          case "DateType" :
              return "Date";
          case "EmailType" :
              return "Email";
          case "ListType" :
              return {
                      TAG: "List",
                      _0: listOptions
                    };
          case "MsisdnType" :
              return "Msisdn";
          case "NumberType" :
              return "Number";
          default:
            return "Text";
        }
      } else {
        return "Text";
      }
  }
}

function availableOperators(kind) {
  if (typeof kind === "object") {
    return {
            hd: "eq",
            tl: {
              hd: "neq",
              tl: {
                hd: "in_list",
                tl: {
                  hd: "blank",
                  tl: {
                    hd: "present",
                    tl: /* [] */0
                  }
                }
              }
            }
          };
  }
  switch (kind) {
    case "Number" :
    case "Date" :
        return numericOperators;
    case "ContextSourceType" :
    case "ContextCampaignUid" :
        return contextSelectOperators;
    case "ContextPipeline" :
        return {
                hd: "eq",
                tl: {
                  hd: "neq",
                  tl: {
                    hd: "blank",
                    tl: {
                      hd: "present",
                      tl: /* [] */0
                    }
                  }
                }
              };
    default:
      return {
              hd: "contains",
              tl: {
                hd: "not_contains",
                tl: {
                  hd: "starts_with",
                  tl: {
                    hd: "ends_with",
                    tl: {
                      hd: "eq",
                      tl: {
                        hd: "neq",
                        tl: {
                          hd: "in_list",
                          tl: {
                            hd: "matches_format",
                            tl: {
                              hd: "blank",
                              tl: {
                                hd: "present",
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            };
  }
}

function defaultOperator(kind) {
  var ops = availableOperators(kind);
  if (ops) {
    return ops.hd;
  } else {
    return "eq";
  }
}

function isOperatorValid(op, kind) {
  return Belt_List.some(availableOperators(kind), (function (validOp) {
                return validOp === op;
              }));
}

function valueInputFor(fieldKind, op, fieldOptions) {
  switch (op) {
    case "in_list" :
        if (typeof fieldKind !== "object") {
          switch (fieldKind) {
            case "ContextSourceType" :
                return {
                        TAG: "MultiSelectComma",
                        _0: ImportEnrichmentFieldOptions$ReactHooksTemplate.sourceTypeOptions
                      };
            default:
              return "TextInput";
          }
        } else {
          var options = fieldKind._0;
          if (options.length !== 0) {
            return {
                    TAG: "MultiSelectComma",
                    _0: Belt_List.fromArray(options)
                  };
          } else {
            return "TextInput";
          }
        }
    case "gt" :
    case "gte" :
    case "lt" :
    case "lte" :
        break;
    case "matches_format" :
        return "FormatPreset";
    case "blank" :
    case "present" :
        return "NoValue";
    default:
      if (typeof fieldKind !== "object") {
        switch (fieldKind) {
          case "Number" :
              return "NumberInput";
          case "Date" :
              return "DateInput";
          case "ContextSourceType" :
              return {
                      TAG: "SingleSelect",
                      _0: ImportEnrichmentFieldOptions$ReactHooksTemplate.sourceTypeOptions
                    };
          case "ContextCampaignUid" :
              return {
                      TAG: "SingleSelect",
                      _0: ImportEnrichmentFieldOptions$ReactHooksTemplate.campaignUidValues(fieldOptions)
                    };
          case "ContextPipeline" :
              return {
                      TAG: "SingleSelect",
                      _0: ImportEnrichmentFieldOptions$ReactHooksTemplate.pipelineOptions
                    };
          default:
            return "TextInput";
        }
      } else {
        var options$1 = fieldKind._0;
        if (options$1.length !== 0) {
          return {
                  TAG: "SingleSelect",
                  _0: Belt_List.fromArray(options$1)
                };
        } else {
          return "TextInput";
        }
      }
  }
  if (typeof fieldKind === "object") {
    return "TextInput";
  }
  switch (fieldKind) {
    case "Number" :
        return "NumberInput";
    case "Date" :
        return "DateInput";
    default:
      return "TextInput";
  }
}

function valuePlaceholder(fieldKind, op) {
  if (op === "in_list") {
    return "comma-separated values";
  }
  if (typeof fieldKind === "object") {
    return "text to match";
  }
  switch (fieldKind) {
    case "Number" :
        return "numeric value";
    case "Date" :
        return "YYYY-MM-DD or date value";
    case "ContextFreeText" :
        return "file name or pattern";
    default:
      return "text to match";
  }
}

function normalizeOnPathChange(row, newPath, fieldOptions) {
  var kind = fieldKindForPath(newPath, fieldOptions);
  var op = defaultOperator(kind);
  return {
          id: row.id,
          path: newPath,
          op: op,
          value: "",
          pattern: "",
          format: "email",
          caseSensitive: false,
          regexMode: "Simple",
          builderMatchType: "contains",
          builderText: ""
        };
}

function normalizeOnOperatorChange(row, newOp, kind, fieldOptions) {
  var op = isOperatorValid(newOp, kind) ? newOp : defaultOperator(kind);
  var match = valueInputFor(kind, op, fieldOptions);
  var needsValue;
  if (typeof match !== "object") {
    switch (match) {
      case "NoValue" :
      case "FormatPreset" :
          needsValue = false;
          break;
      default:
        needsValue = true;
    }
  } else {
    needsValue = true;
  }
  return {
          id: row.id,
          path: row.path,
          op: op,
          value: needsValue ? row.value : "",
          pattern: row.pattern,
          format: row.format,
          caseSensitive: row.caseSensitive,
          regexMode: row.regexMode,
          builderMatchType: row.builderMatchType,
          builderText: row.builderText
        };
}

exports.fieldKindForPath = fieldKindForPath;
exports.availableOperators = availableOperators;
exports.defaultOperator = defaultOperator;
exports.isOperatorValid = isOperatorValid;
exports.valueInputFor = valueInputFor;
exports.normalizeOnPathChange = normalizeOnPathChange;
exports.normalizeOnOperatorChange = normalizeOnOperatorChange;
exports.valuePlaceholder = valuePlaceholder;
/* ImportEnrichmentFieldOptions-ReactHooksTemplate Not a pure module */
